import { useState } from "react";
import { downloadExcelByDateRange } from "../model/MatRequestModel";
// import { useToast } from "fe_comp_base";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import { formattedDate } from "../model/MaterialCreationMethods";

const UploadTemplatesVM = () => {
  const { handleToastOpen } = useToast();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (value) => {
    
    setStartDate(value);
  };

  const handleEndDateChange = (value) => {
    
    setEndDate(value);
  };

const handleUpload = async (buttonKey, selectedTemplate) => {
  try {
    //  Field-specific validation 
    const missingFields = [];
    if (!startDate) missingFields.push("Start Date");
    if (!endDate) missingFields.push("End Date");
    if (!selectedTemplate) missingFields.push("Template Type");

    if (missingFields.length > 0) {
      handleToastOpen("error", `${missingFields.join(", ")} is required.`);
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start > end) {
      handleToastOpen("error", "Start Date cannot be after End Date.");
      
      return;
    }

    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (start > today || end > today) {
      handleToastOpen("error", "Future dates are not allowed.");
      return;
    }
    // ─────────────────────────────────────────────────────────────────

    const response = await downloadExcelByDateRange(startDate, endDate, buttonKey);

    // ── Empty file check ──────────────────────────────────────────────
    const blob = new Blob([response.data]);
    if (!response.data || blob.size === 0) {
      handleToastOpen(
        "error",
        `No records found for "${buttonKey}" in the selected date range. Please try a different range.`
      );
      return;
    }
    // ─────────────────────────────────────────────────────────────────

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob); // ← reuse blob
    link.download = `${buttonKey}_${formattedDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleToastOpen("success", "File Downloaded Successfully");

  } catch (error) {
    handleToastOpen(
      "error",
      error.response?.data?.message || "File download unsuccessful."
    );
  }
};

  return {
    handleStartDateChange,
    handleEndDateChange,
    handleUpload,
  };
};

export default UploadTemplatesVM;
